// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryPage_container__oeYXj","header":"CategoryPage_header__WPnDn","noarticles":"CategoryPage_noarticles__QaIrO"};